import React, {useEffect} from 'react';
import ReportUtils from "../../../../../utils/report-utils.js";
import ReportCard from "../../../../../components/reports/report-card.jsx";

const CardsContent = ({ data }) => {
    useEffect(() => {
        const values = [
            ["Ausências", data?.kpis.totalAbsences  ?? 0],
            ["Dias ausentes", data?.kpis.totalDaysOff ?? 0],
            ["Média de dias por ausência", data?.kpis.averageDaysPerAbsence ?? 0]
        ];

        ReportUtils.createExportableTable(["Descrição", "Quantidade"], values, 'Cards')
    }, [data]);

    return (
        <>
            <div className="flex flex-col">
                <div className="grid grid-cols-3">
                    <ReportCard title="Ausências" value={data?.kpis.totalAbsences ?? 0}/>
                    <ReportCard title="Dias ausentes" value={data?.kpis.totalDaysOff ?? 0}/>
                    <ReportCard title="Média de dias por ausências" value={data?.kpis.averageDaysPerAbsence ?? 0}/>
                </div>
            </div>

            <div className="chart-divisor"/>
        </>
    );
};

export default CardsContent;